import { Grid, Typography } from "@mui/material";
import { REQUIRED_FIELD_COLOR } from "./requiredField";

/** Legend for the red labels. Renders as a full-width item of the step's Grid container. */
const RequiredFieldsNote = () => (
  <Grid item xs={12}>
    <Typography sx={{ color: REQUIRED_FIELD_COLOR, fontSize: "0.85rem" }}>
      Items in red must be completed.
    </Typography>
  </Grid>
);

export default RequiredFieldsNote;
